var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row mt-3" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "primary", size: "sm" },
              on: { click: _vm.voltar }
            },
            [
              _c("i", { staticClass: "fas fa-arrow-left" }),
              _vm._v("\n            Voltar")
            ]
          ),
          _vm._v(" "),
          _vm.hasPermission("varejo_propostas")
            ? _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "primary", size: "sm" },
                  on: { click: _vm.propostaVarejo }
                },
                [
                  _c("i", { staticClass: "fas fa-fire" }),
                  _vm._v(" Propostas Varejo\n        ")
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row mt-2" },
        [
          _c(
            "b-card",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "end" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "1" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Pedido")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              id: "filter-input",
                              type: "search"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.listaPedidos()
                              }
                            },
                            model: {
                              value: _vm.filtro.pedido,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "pedido", $$v)
                              },
                              expression: "filtro.pedido"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Cliente")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              id: "filter-input",
                              type: "search",
                              placeholder: "Código ou Nome"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.listaPedidos()
                              }
                            },
                            model: {
                              value: _vm.filtro.cliente,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "cliente", $$v)
                              },
                              expression: "filtro.cliente"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Pedido Protheus")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              id: "filter-input",
                              type: "search",
                              placeholder: "Código"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.listaPedidos()
                              }
                            },
                            model: {
                              value: _vm.filtro.protheus,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "protheus", $$v)
                              },
                              expression: "filtro.protheus"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Nota Fiscal")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              id: "filter-input",
                              type: "search",
                              placeholder: "Número"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.listaPedidos()
                              }
                            },
                            model: {
                              value: _vm.filtro.nota,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "nota", $$v)
                              },
                              expression: "filtro.nota"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "1" } },
                        [
                          _c("label", { attrs: { for: "" } }, [_vm._v("Tipo")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { size: "sm", options: _vm.optionsTipo },
                            model: {
                              value: _vm.filtro.tipo,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "tipo", $$v)
                              },
                              expression: "filtro.tipo"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "1" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Situação")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { size: "sm", options: _vm.optionsStatus },
                            model: {
                              value: _vm.filtro.status,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "status", $$v)
                              },
                              expression: "filtro.status"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: _vm.isLoading,
                                size: "sm",
                                variant: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.listaPedidos()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-search" }),
                              _vm._v(" Buscar\n                        ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                staticClass: "mt-2",
                attrs: {
                  hover: "",
                  "show-empty": "",
                  small: "",
                  items: _vm.pedidos,
                  busy: _vm.isLoading,
                  fields: _vm.header,
                  stacked: "md",
                  "empty-text": "Nenhum pedido encontrado ..."
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Carregando ...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(proposta)",
                    fn: function(row) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.verProposta(row.item.proposta.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(row.item.proposta.id))]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(actions)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: row.item.xml.length > 0,
                                expression: "row.item.xml.length > 0"
                              }
                            ],
                            attrs: {
                              title: "Nota Fiscal",
                              variant: "success",
                              size: "sm"
                            },
                            on: {
                              click: function($event) {
                                return _vm.gerarNota(row.item.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "far fa-file-pdf" })]
                        ),
                        _vm._v(" "),
                        row.item.xml.length && row.item.xml[0].xml_brinde
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  title: "Nota Fiscal Brinde",
                                  variant: "outline-success",
                                  size: "sm"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.gerarNotaBrinde(row.item.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "far fa-file-pdf" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              title: "Detalhar Pedido",
                              variant: "primary",
                              size: "sm"
                            },
                            on: {
                              click: function($event) {
                                return _vm.imprimir(row.item.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-file-alt" })]
                        ),
                        _vm._v(" "),
                        _vm.hasFalta(row.item)
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  title: "Gerar Pedido Faltante",
                                  variant: "warning",
                                  size: "sm"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.getPedidoFaltante(row.item.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-recycle" })]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-left" },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "fill"
                        },
                        on: {
                          input: function($event) {
                            return _vm.listaPedidos()
                          }
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "1" } },
                    [
                      _c("b-select", {
                        attrs: {
                          options: [5, 10, 20, 50, 100],
                          title: "Por Página"
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n                    Total de Registros: " +
                        _vm._s(_vm.totalRows) +
                        "\n                "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n            Pedido: " +
                      _vm._s(_vm.pedidoFaltas.id) +
                      "\n        "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled: _vm.loadingFalta
                      },
                      on: {
                        click: function($event) {
                          return _vm.gerarPedidoFaltante()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-recycle" }),
                      _vm._v(" Gerar Pedido de Faltas\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "danger",
                        size: "sm",
                        disabled: _vm.loadingFalta
                      },
                      on: {
                        click: function($event) {
                          _vm.modalPedido = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalPedido,
            callback: function($$v) {
              _vm.modalPedido = $$v
            },
            expression: "modalPedido"
          }
        },
        [
          _vm._v(" "),
          _vm.pedidoFaltas.id
            ? _c(
                "b-card",
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.loadingFalta, rounded: "sm" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("b", [_vm._v("Cliente:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.pedidoFaltas.distribuidor.codigo) +
                                " - " +
                                _vm._s(_vm.pedidoFaltas.distribuidor.nome) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-col", [
                            _c("b", [_vm._v("Tipo da Proposta: ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.pedidoFaltas.proposta.tipo_proposta
                                ) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("b", [_vm._v("Status: ")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.pedidoFaltas.status) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-col", [
                            _c("b", [_vm._v("Data do Pedido: ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDate(_vm.pedidoFaltas.created_at)
                                ) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-table", {
                            attrs: {
                              items: _vm.pedidoFaltas.itens,
                              fields: _vm.fieldsPedidoFaltas,
                              small: "",
                              striped: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(actions)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "50px" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: { size: "sm" },
                                            on: {
                                              change: function($event) {
                                                !row.item.qtd_recuperar ||
                                                row.item.qtd_recuperar == "" ||
                                                row.item.qtd_recuperar >
                                                  row.item.qtdARecuperar ||
                                                row.item.qtd_recuperar <= 0
                                                  ? (row.item.qtd_recuperar =
                                                      row.item.qtdARecuperar)
                                                  : row.item.qtd_recuperar
                                              }
                                            },
                                            model: {
                                              value: row.item.qtd_recuperar,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "qtd_recuperar",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.qtd_recuperar"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3332304274
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h1", [_vm._v("Pedidos Varejo")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daecef88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daecef88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/pedidos/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-daecef88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/pedidos/index.vue
// module chunks = 2